export default __webpack_public_path__ + "static/media/photo_pto-min.7272ac96.jpg";